import { NavigateBackLink } from '@exam-center/components';
import { Label, PageHeader } from '@shared/components';

import { REGISTRATION_STATUS_COLOR, REGISTRATION_STATUS_TEXT } from '../../constants';
import { useProctoringRegistrationDetails } from '../../providers';

export default function ProctoringRegistrationDetailsPageHeader() {
  const { examCenterCode, examEventId, examinee, examEventExaminee, loading } =
    useProctoringRegistrationDetails();
  const { title, firstName, middleName, lastName } = examinee;
  const { registrationStatus } = examEventExaminee;

  return (
    <PageHeader
      title={`${title} ${firstName}${middleName ? ` ${middleName}` : ''} ${lastName}`}
      linkAdornment={
        <NavigateBackLink
          to='/:examCenterCode/proctoring/exam-events/:examEventId/registrations'
          params={{
            examCenterCode: examCenterCode,
            examEventId: examEventId,
          }}
          label='Back'
        />
      }
      endAdornment={(() => {
        const labelColor = REGISTRATION_STATUS_COLOR[registrationStatus];
        if (loading) {
          return null;
        }
        return (
          <Label variant='outlined' color={labelColor} size='large'>
            {REGISTRATION_STATUS_TEXT[registrationStatus]}
          </Label>
        );
      })()}
    />
  );
}
